// src/api.js
// Muster: identisch zum CRM (MeinKleinesCRM) - axios-Instanz mit relativer baseURL.
// Der CRA-Dev-Server leitet /api/* über den "proxy"-Eintrag in package.json
// an DatenLeserWeb weiter, im Produktivbetrieb übernimmt das der Reverse-Proxy/Webserver.
import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

export default api;
